import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import templateGroupsReducer from '@app/reducers/entities/template-groups';
import { TEMPLATE_GROUPS_QUERY } from '@flow/libs/data-fields';

const useTemplateGroups = () => {
  const templateGroupsQuery = useSelector((state) =>
    templateGroupsReducer.getQuerySelector(state, {
      name: TEMPLATE_GROUPS_QUERY,
    }),
  );

  const templateGroups = useSelector((state) =>
    templateGroupsReducer.getTemplateGroupsSelector(state, {
      ids: templateGroupsQuery.result,
    }),
  );

  return templateGroups;
};

export default useTemplateGroups;

export const useFetchTemplateGroups = (
  { enabled }: { enabled: boolean } = {
    enabled: true,
  },
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (enabled) {
      dispatch(
        templateGroupsReducer.queryTemplateGroups({
          name: TEMPLATE_GROUPS_QUERY,
        }),
      );
    }
  }, [
    dispatch,
    enabled,
  ]);
};
